export default request => ({
	get() {
		return request({
			path: "users/groups",
			method: "get"
		});
	}
});
